import { useState, useEffect } from "react";
import SectionTitle from "../../components/SectionTitle";
import SocialLink from "../../components/SocialLink";
import { SkillsContainer, SkillsStyled } from "./styles";
import { client, getSkills } from "../../client";
import imageUrlBuilder from "@sanity/image-url";

const builder = imageUrlBuilder(client);

function urlFor(source) {
  return builder.image(source);
}

function Skills() {
  const [skills, setSkills] = useState();

  const callGetSkills = async () => {
    const res = await getSkills();
    setSkills(res);
  };

  useEffect(() => {
    callGetSkills();
  }, []);


  return (
    <SkillsStyled>
      <SkillsContainer>
        <SectionTitle text="Skills" />
        {skills &&
          skills?.map((skillItem) => (
            <SocialLink
              imgSrc={urlFor(skillItem?.skillImage)}
              title={skillItem?.skill}
              link={skillItem?.link}
            />
          ))}
      </SkillsContainer>
    </SkillsStyled>
  );
}

export default Skills;
